import Controller, { OnChange, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { Inject } from '@odinjs/odin';
import { AutocompleteAPI, ButtonAPI, FieldAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../../constants/endpoints';

import './eletronic-service-reason-justification-controller.css';
import { Value } from '@philips-internal/oswald-ui-core';

interface EletronicService {
  justification: string;
  reasonType: {
    dsReason: string,
    nrSequence: number
  }
}
@Controller({ fragment: 'electronic-service-reason-justification' })
class EletronicServiceReasonJustificationController extends BaseController {
  @Inject('form-reason-justification')
  form!: FormAPI;

  @Inject('clear-filter-button')
  buttomClear!: ButtonAPI;

  @Inject('apply-filter-button')
  buttomSend!: ButtonAPI;

  @Inject('field-text-area-justification')
  fieldJustification!: FieldAPI;

  @Inject('autocomplete-reason')
  autocomplete!: AutocompleteAPI;

  @Inject('field-text-reason')
  fieldReason!: FieldAPI;

  @Inject('autocomplete-reason')
  textReason!: AutocompleteAPI;

  @OnMount({ target: 'layout-eletronic-service-reason-justification' })
  onMount(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    this.context.set({ encounterId, patientId })
    this.form.validate();
  }

  @OnChange({ target: 'text-area-justification' })
  onChangeInputTextArea(event: FormAPI): void {
    this.context.set({ valueTextArea: event.getValue() });
  }

  @OnClick({ target: 'apply-filter-button' })
  async onClickSend(): Promise<void> {
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();
    const isValid = await this.form.validate();
    if (!isValid) {
      return
    }
    const eletronicService = this.form.getRecord() as unknown as EletronicService;
    const body = {
      dsReason: eletronicService.justification,
      nrSequence: eletronicService.reasonType.nrSequence,
      readingMode: 'D',
    }
    HttpService.post(
      Endpoint.POST_NEW_REASON_JUSTIFICATION, {
        encounterId: encounterId,
        patientId: patientId,
      }, { body });
    applicationContext.redirect(ApplicationRoute.ADEP_ELETRONIC_SERVICE_PERSONAL_INFORMATION, {
      encounterId,
      patientId,
    });
  }

  @OnClick({ target: 'clear-filter-button' })
  onClickClear(): void {
    this.fieldJustification.setValue('');
    this.autocomplete.setValue({} as Record<string, Value>);
  }

}

export default EletronicServiceReasonJustificationController;
